class StickyProductBar extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector('[id^="MainProduct-"] .product-form__submit');
    if (!this.target) return;

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      this.classList.toggle('sticky-product-bar--visible', entry.boundingClientRect.top < 0);
    });
    this.observer.observe(this.target);

    this.addButton = this.querySelector('[data-sticky-add-to-cart]');
    if (this.addButton) {
      this.addButton.disabled = this.target.hasAttribute('disabled');
      // Reuse the real product form's own add-to-cart handler instead of
      // duplicating its AJAX/cart-notification logic here.
      this.addButton.addEventListener('click', () => this.target.click());
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('sticky-product-bar')) {
  customElements.define('sticky-product-bar', StickyProductBar);
}
